'use strict';

if ( typeof less !== 'undefined' ) {

    $.holdReady(true);

    // setTimeout(function() {
    //     console.clear();
    //     $.holdReady(false);
    // }, 10000);

    less.pageLoadFinished.then(function() {
        console.clear();
        $.holdReady(false);
    });

}

$(function() {

    App.init();
    App.MainMenu();
    App.Comments.init();
    App.Likes.init();

    App.FormPlaceholders();
    App.AjaxForms();

    if ( App.interfaceName === 'home_page' ) {
        App.HomePartners();
        App.HomeEqualHeights.init();
    }

    if ( App.interfaceName === 'archive' ) {
        App.Gallery();
    }

    if ( App.interfaceName === 'page_subscription' ) {
        FlexitesSubscribe.Form('subscribe-form');
    }

});

App.FormPlaceholders = function( context ) {

    var $context = $(context || document.body);

    if ( App.elementSupportsAttribute('input', 'placeholder') ) {
        $context.find('.form.m--placeholders').each(function() {
            $(this).find('.form__field')
                .filter('.short_text, .long_text, .e_mail')
                .find('.form__label').hide();
        });
    }

}

App.MainMenu = function() {

    $('.main-menu__item').hover(function() {
        $(this).find('.main-menu__sub').stop(true, true).fadeIn();
    }, function() {
        $(this).find('.main-menu__sub').stop(true, true).fadeOut();
    });

}

App.AjaxForms = function() {

    $('.js-ajax-form').click(function( event ) {

        event.preventDefault();

        var params = { form_id: $(this).data('form-id') };
        App.getJSON('get_form', params, showContent, { checkStatus: false });

    });

    function showContent( data ) {

        if ( data.ok ) {

            $.fancybox(data.html);

            var $context = $('.ajax-content');

            App.FormPlaceholders($context);

            $context.find('.form form').submit(function( event ) {

                event.preventDefault();

                var $form = $(this);

                if ( $form.find('.form__field.file').length ) {

                    var options = {
                        type:     'post',
                        url:      '/json/send_form/',
                        dataType: 'json',
                        success:  showContent,
                        error: function() {
                            alert('Произошла ошибка при загрузке данных. Попробуйте перезагрузить страницу.');
                        }
                    };

                    $form.ajaxSubmit(options);

                } else {

                    var params = $form.serializeArray();
                    App.getJSON('send_form', params, showContent, { checkStatus: false });

                }

            });

        } else if ( data.errors ) {

            var $fields = $('.ajax-content .form .form__field, .ajax-content .form .form__agreement, .ajax-content .form .form__captcha').removeClass('has-error');

            for ( var p in data.errors ) {
                $fields.filter('.attr-'+p).addClass('has-error');
            }

        }

    }

}

App.HomeEqualHeights = (function() {

    function init() {

        // Авторская колонка
        var $authorsItems = $('.home-authors__item-inner');
        var $authorsTexts = $authorsItems.find('.author-article__text');

        $(window).on('resize', function() {

            $authorsTexts.height('');
            $authorsItems.height('');

            equalize($authorsItems);

            $authorsTexts.each(function() {
                var $this = $(this);
                var height = $this.innerHeight();
                var itemHeight = $this.closest('.home-authors__item-inner').height();
                if ( height !== itemHeight ) { $this.innerHeight(itemHeight); }
            });

        }).trigger('resize');

    }

    function equalize( $items ) {

        var maxHeight = 0;

        $items.each(function() {
            var height = $(this).height();
            if ( height > maxHeight ) { maxHeight = height; }
        });

        // $items.height(maxHeight);

        $items.each(function() {
            var $this = $(this);
            var height = $this.height();
            if ( height !== maxHeight ) { $this.height(maxHeight); }
        });

    }

    return {
        init: init
    }

})();

App.Comments = (function() {

    var $wrap, $reply, $replyReset, $commentCount;
    // var parentId = 0;
    var $parentId;

    function init() {

        $wrap = $('.comments');
        // $commentCount = $('#comment_count');

        $reply = $wrap.find('.comments__reply');
        $reply.find('form').submit(replySubmit);
        $replyReset = $wrap.find('.comments__reply-reset');
        $parentId = $reply.find('input[name="parent_id"]');

        $wrap.on('click', '.comments__reply-reset-button', replyResetButtonClick);

        $wrap.on('click', '.comment__replies-button', repliesButtonClick);
        $wrap.on('click', '.comment__reply-button', replyButtonClick);
        $wrap.on('click', '.comment__delete-button', deleteButtonClick);
        $wrap.on('click', '.comment__publish-button', publishButtonClick);
        $wrap.on('click', '.comment__not-publish-button', notPublishButtonClick);

        $wrap.find('.comment').each(function() {
            var $comment = $(this);
            $comment.children('.comment__replies').hide();
            $comment.data('collapsed', true);
            $comment.find('.comment__replies-button').text('ответы');
            $comment.find('> .comment__footer .comment__replies-count').show();
        });

        $wrap.find('.form__captcha').hide();

    }

    function repliesButtonClick() {

        var $button  = $(this);
        var $comment = $button.closest('.comment');
        var $replies = $comment.children('.comment__replies');
        var $count   = $comment.find('> .comment__footer .comment__replies-count');

        if ( $comment.data('collapsed') ) {

            $replies.slideDown();
            $comment.data('collapsed', false);
            $button.text('скрыть ответы');
            $count.hide();

        } else {

            $replies.slideUp();
            $comment.data('collapsed', true);
            $button.text('ответы');
            $count.show();

        }

    }

    function replyButtonClick( event ) {

        event.preventDefault();

        var $button  = $(this);
        var $comment = $button.closest('.comment');
        var $footer  = $comment.children('.comment__footer');

        $reply.insertAfter($footer);

        // parentId = $comment.data('id');
        $parentId.val($comment.data('id'));

        $replyReset.show();

    }

    function replyResetButtonClick( event ) {

        event.preventDefault();

        $reply.insertBefore($replyReset);

        $parentId.val(0);

        $replyReset.hide();

    }

    function deleteButtonClick( event ) {

        event.preventDefault();

        var $button  = $(this);
        var $comment = $button.closest('.comment');

        if ( confirm('Удалить комментарий?') ) {

            App.getJSON('delete_comment', { comment_id: $comment.data('id') }, function( data ) {

                if ( data.status ) {

                    if ( $reply.closest($comment).length ) {
                        $reply.appendTo($wrap);
                    }

                    $comment.children('.comment__body').html('<em>комментарий удален</em>');

                    $comment.children('.comment__header').remove();
                    $comment.children('.comment__footer').remove();
                    // $comment.find('> .comment__footer .comment__reply-button').remove();
                    // $comment.find('> .comment__footer .comment__delete-button').remove();

                    // var count = $commentCount.data('count');
                    // count--;
                    // $commentCount.data('count', count).text(count);

                } else {

                    alert(data.error);

                }

            });

        }

    }

    function publishButtonClick( event ) {

        event.preventDefault();

        var $button  = $(this);
        var $comment = $button.closest('.comment');

        // if ( confirm('Опубликовать комментарий?') ) {

            App.getJSON('publish_comment', {
                comment_id: $comment.data('id'),
                publication: true
            }, function( data ) {

                if ( data.status ) {

                    $button.replaceWith('<a class="comment__not-publish-button" href="javascript:;">не публиковать</a>');

                } else {

                    alert(data.error);

                }
            });

        // }

    }

    function notPublishButtonClick( event ) {

        event.preventDefault();

        var $button  = $(this);
        var $comment = $button.closest('.comment');

        // if ( confirm('Отменить публикацию комментария?') ) {

            App.getJSON('publish_comment', {
                comment_id: $comment.data('id'),
                publication: false
            }, function( data ) {

                if ( data.status ) {

                    $button.replaceWith('<a class="comment__publish-button" href="javascript:;">публиковать</a>');

                } else {

                    alert(data.error);

                }
            });

        // }

    }

    function replySubmit( event ) {

        event.preventDefault();

        var person = $reply.find('[name=person]').val();
        person = $.trim(person);

        var content = $reply.find('[name=content]').val();
        content = $.trim(content);
        if ( content === '' ) {
            alert('Напишите что-нибудь');
            return;
        }

        /* var captcha = '';
        var $captcha = $reply.find('[name=__captcha_answer]');
        if ( $captcha.length ) {
            captcha = $.trim($captcha.val());
            if ( captcha === '' ) {
                var $message = $reply.find('.form__captcha .form__label');
                var message = $.trim($message.text());
                alert(message);
                return;
            }
        } */

        App.getJSON('add_comment', {
            // parent_id:      parentId,
            parent_id:      $reply.find('[name=parent_id]').val(),
            node_id:        $reply.find('[name=node_id]').val(),
            person:         person,
            content:        content,
            // captcha:        captcha
        }, function( data ) {

            if ( data.status ) {

                location.reload();

            } else {

                alert(data.error);

            }

        });

    }

    return {
        init: init
    }

})();

App.Likes = (function() {

    var $buttons;

    function init() {

        $buttons = $('.js-like');

        $buttons.each(function() {

            var $button = $(this);
            var nodeId = $button.data('node-id');

            var isActive = $.cookie('Likes_' + nodeId) == 1;

            $button.toggleClass('is-active', isActive);

        });

        $buttons.click(buttonClick);

    }

    function buttonClick( event ) {

        event.preventDefault();

        var $button = $(this);
        var nodeId = $button.data('node-id');

        var isActive = $button.hasClass('is-active');
        var action = isActive ? 'delete_like' : 'add_like';

        App.getJSON(action, { node_id: nodeId }, function( data ) {

            if ( data.status ) {

                // $button.toggleClass('is-active');
                // $button.text(data.count);

                $buttons
                    .filter(function() {
                        return $(this).data('node-id') == nodeId;
                    })
                    .toggleClass('is-active')
                    .text(data.count);

                if ( isActive ) {
                    $.removeCookie('Likes_' + nodeId, { path: '/' });
                } else {
                    var date = new Date();
                    date.setDate(date.getDate() + 1);
                    date.setHours(0);
                    date.setMinutes(0);
                    date.setSeconds(0);
                    $.cookie('Likes_' + nodeId, 1, { expires: date, path: '/' });
                }

            } else {

                alert(data.error);

            }

        });

    }

    return {
        init: init
    }

})();

App.Gallery = function() {

    $('.gallery__for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.gallery__nav'
    });

    var count = $('.gallery__nav .gallery__item').length;

    $('.gallery__nav').slick({
        slidesToShow: count > 3 ? 3 : 1, // 3,
        slidesToScroll: 1,
        asNavFor: '.gallery__for',
        arrows: false,
        dots: true,
        centerMode: count > 3,
        focusOnSelect: true,
        infinite: count > 3,
        variableWidth: true
    });

};

App.HomePartners = function() {

    var $list = $('.home-partners__list');

    $list.slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            }, {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            }
        ]
    });

    $list.find('.home-partners__item img').click(function() {
        var $inner = $(this).closest('.home-partners__item').find('.home-partners__inner');
        $.fancybox('<div class="ajax-content">' + $inner.html() + '</div>', { scrolling: 'no' });
    });

};

var FlexitesSubscribe = new Object();

FlexitesSubscribe.Form = function(formId) {

    var $form = $(document.getElementById(formId));

    if (!$form.length)
        return;

    var $methodRadio = $form.find('input[name=_action]');

    function update() {
        var action = '';
        for (var i = 0; $methodRadio.length; i++) {
            var inp = $methodRadio.get(i);
            if (inp.checked) {
                action = inp.value;
                break;
            }
        }
        if (action == 'unsubscribe') {
            $form.find('.attr-subscribe-name, .attr-subscribe-groups').hide();
        } else {
            $form.find('.attr-subscribe-name, .attr-subscribe-groups').show();
        }
    }

    $methodRadio.click(function() {
        update();
    });

    update();

}
